import { Box, Divider, Skeleton } from '@mui/material';
import ButtonWrapper from '../../formUtilities/useButton';
import TextWrapper from '../../formUtilities/useTextWrapper';
import DownloadIcon from '@mui/icons-material/Download';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import PropTypes from 'prop-types';

SectionWithHeading.propTypes = {
	heading: PropTypes.string,
	children: PropTypes.element,
	actionButtons: PropTypes.element,
	statusLabel: PropTypes.any,
	downloadCSV: PropTypes.bool,
	isEditButton: PropTypes.bool,
	isEditToggle: PropTypes.bool,
	hideEditBtn: PropTypes.bool,
	loading: PropTypes.bool,
	cardClass: PropTypes.string,
	headingClass: PropTypes.string,
	onDownload: PropTypes.func,
	onEditInfo: PropTypes.func,
};

export default function SectionWithHeading({
	heading = null,
	children,
	actionButtons,
	statusLabel = '',
	downloadCSV = false,
	isEditButton = false,
	isEditToggle = false,
	hideEditBtn = false,
	hideHeadingDivider = false,
	loading = false,
	cardClass = '',
	headingClass = '',
	hideHeader = false,
	actionSkeleton = true,
	cardBodyClass = '',
	headingContainerClass = '',
	onDownload = () => { },
	onEditInfo = (e) => { },
}) {
	return (
		<>
			<Box
				className={`card !p-0 rounded-md flex flex-col items-start ${cardClass ? cardClass : ''
					}`}
				style={{ height: 'fit-content' }}>
				{!hideHeader ? (
					<>
						<Box className={`flex justify-between flex-col md:flex-row w-full p-4 flex-0 h-auto ${headingContainerClass}`}>
							<Box className="flex flex-0 items-center mb-4 md:mb-0">
								{!loading ? (
									<>
										<TextWrapper
											type="span"
											classList={`${headingClass} !text-xl !font-[500] !mr-3 !text-start`}
											text={heading}></TextWrapper>
										{statusLabel ? statusLabel : null}
									</>
								) : (
									<>
										<Skeleton
											variant="text"
											sx={{ fontSize: '1.5rem', width: '300px' }}
										/>
									</>
								)}
							</Box>
							<Box className="flex flex-0 items-center justify-end">
								{!loading ? (
									<>
										{downloadCSV ? (
											<ButtonWrapper
												classList={`${actionButtons || isEditButton ? '!mr-3' : ''
													}`}
												onClick={() => onDownload && onDownload()}
												label="Download"
												icon={<DownloadIcon />}></ButtonWrapper>
										) : (
											''
										)}
										{actionButtons ? actionButtons : null}
										{isEditButton ? (
											<>
												<ButtonWrapper
													hideBtn={hideEditBtn}
													classList={`${actionButtons ? '!ml-3' : ''}`}
													onClick={(e) => {
														onEditInfo(e);
													}}
													type={!isEditToggle ? 'button' : 'submit'}
													variant={'outlined'}
													label={!isEditToggle ? 'Edit' : 'Save'}
													icon={
														!isEditToggle ? <EditIcon /> : <SaveIcon />
													}></ButtonWrapper>
											</>
										) : null}
									</>
								) : (
									<>
										<Box className="grid grid-cols-3 gap-3 w-full">
											{actionButtons && actionSkeleton ? (
												<>
													<Skeleton
														variant="text"
														sx={{ fontSize: '2rem', width: '100px' }}
													/>
													<Skeleton
														variant="text"
														sx={{ fontSize: '2rem', width: '100px' }}
													/>
													<Skeleton
														variant="text"
														sx={{ fontSize: '2rem', width: '100px' }}
													/>
												</>
											) : null}
										</Box>
									</>
								)}
							</Box>
						</Box>
						{!hideHeadingDivider ? <Divider className="w-full"></Divider> : null}

					</>
				) : (
					<></>
				)}
				<Box className={`p-4 w-full ${cardBodyClass ? cardBodyClass : ''}`}>
					{!loading ? (
						<>{children}</>
					) : (
						<>
							{[1, 2, 3].map((resp) => {
								return (
									<Box
										key={resp}
										className="grid grid-flow-row gap-2">
										<Box className="grid grid-cols-3 gap-6">
											<Skeleton
												variant="text"
												sx={{ fontSize: '2rem', width: '100%' }}
											/>
											<Skeleton
												variant="text"
												sx={{ fontSize: '2rem', width: '100%' }}
											/>
											<Skeleton
												variant="text"
												sx={{ fontSize: '2rem', width: '100%' }}
											/>
										</Box>
									</Box>
								);
							})}
						</>
					)}
				</Box>
			</Box>
		</>
	);
}
